import styled from 'styled-components';

// eslint-disable-next-line
export const TransactionsPage = styled.div``;
